"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CierrePartner() {
  return <>
      <BloqueCeroCajaNegra />
      <BloqueCtaPartner />
    </>;
}
function BloqueCeroCajaNegra() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="partner-caja-negra" id="cero-caja-negra" className="bg-background text-foreground py-24 md:py-32 overflow-hidden border-t border-border/30">
      <div className="container mx-auto px-6 md:px-8 max-w-4xl">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-normal text-foreground leading-tight mb-10">
            Cero caja negra.
          </h2>

          <div className="space-y-6 font-sans text-lg md:text-xl text-foreground/90 leading-relaxed max-w-2xl">
            <p>
              Cada componente que construimos viene con documentación técnica generada automáticamente por nuestro propio sistema. No es servicio extra ni se escribe después como pendiente — es parte de cómo entregamos cada activo.
            </p>

            <p className="text-muted-foreground">Cualquiera con conocimiento básico de sistemas puede entender lo construido y mantenerlo si decides operar in-house. El conocimiento es del cliente, documentado, listo para evolucionar.</p>
          </div>
        </div>
      </div>
    </section>;
}
function BloqueCtaPartner() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="partner-cta" id="cta-partner" className="relative bg-background text-foreground py-32 md:py-40 overflow-hidden border-t border-border/30">
      <div className="absolute inset-0 pointer-events-none" style={{
      backgroundImage: "url(https://fulcro.mx/wp-content/uploads/2026/04/fulcro-textura-fulcrums-dark.svg)",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      opacity: 0.15
    }} aria-hidden="true" />

      <div ref={ref} className={`relative z-10 max-w-3xl mx-auto px-6 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-normal text-foreground leading-tight mb-8">
          El siguiente paso.
        </h2>

        <p className="font-sans text-lg md:text-xl text-muted-foreground leading-relaxed mb-12 max-w-2xl mx-auto">
          Una llamada de 30 minutos para entender si Partner es lo que aplica, o si conviene empezar por Diagnóstico.
        </p>

        <Button asChild size="lg" className="h-14 px-8 text-base font-medium bg-primary hover:bg-primary/90 text-primary-foreground rounded-sm transition-colors">
          <Link to="https://fulcro.mx/contacto/">
            Agendar 30 minutos
            <ArrowRight className="ml-2 size-5" />
          </Link>
        </Button>
      </div>
    </section>;
}